const HAS_NON_ASCII = /\P{ASCII}/u;
const LATIN_BASE_MARKS = /(\p{Script=Latin})\p{M}+/gu;

export const normalizeForSearch = (text: string): string => {
  if (!HAS_NON_ASCII.test(text)) {
    return text.toLowerCase();
  }

  // Fold marks on Latin base letters only — in other scripts marks distinguish
  // letters (й vs и). NFC keeps mixed-script strings comparable to pure ones.
  return text
    .normalize('NFD')
    .replace(LATIN_BASE_MARKS, '$1')
    .normalize('NFC')
    .toLowerCase();
};
